import { TemplateElement, defineElement, html } from '@webtides/element-js';
import '../../../accordion-group/accordion-group.js';
import styles from '../../../../../packages/magnolia-content/magnolia-content.css';

/**
 * @property {string} headline
 */
export default class AccordionGroup extends TemplateElement {
    constructor() {
        super({ shadowRender: true, styles: [styles] });
    }

    properties() {
        return {
            headline: '',
        };
    }

    template() {
        return html`
            <mb-accordion-group show-multiple="false">
                <h2 class="text-xl font-medium text-green-medium mb-8">${this.headline}</h2>
                <slot></slot>
            </mb-accordion-group>
        `;
    }
}

defineElement('mb-e-banking-accordion-group', AccordionGroup);
